module.exports = __webpack_public_path__ + "img/icon_firmware.99adaf96.svg";